import React, { forwardRef } from 'react';
import { View, Heading, Text, colors, BasicChip } from '@fairygodboss/ui';
import ResponsivePicture from '../../../Elements/ResponsivePicture/ResponsivePicture';
import { labelToTextMap } from '../adviceHashMap';
import VisibilityPixel, {
    EmitMetric,
} from '../../../Analytics/VisibilityPixel/VisibilityPixel';

export const FeauturedArticle = forwardRef(({ content, renderKey }, ref) => {
    const {
        commentCount,
        likes,
        contentUrl,
        title,
        contentImage,
        topic,
        hash,
    } = content;
    const label = topic?.label;
    const commentText = commentCount === 1 ? 'Comment' : 'Comments';
    const likeText = likes === 1 ? 'Like' : 'Likes';

    const impressionMetrics = {
        misc_event_type: 'advice-hub-impression',
        community_content_key: hash,
        community_content_location: 'advice-content',
        impression: 1,
        // TODO: if we have sponsored company, add company ID
        company_id: [null],
        snowPlow: {
            component: 'tile',
            tileType: 'article',
            position: 'main',
            pageType: 'collection',
            pageSection: 'advice_landing',
        },
    };

    const emitClickMetric = () => {
        EmitMetric({
            click: 1,
            community_content_key: hash,
            // TODO: if we have sponsored company, add company ID
            company_id: [null],
        });
    };

    return (
        <View position="relative" width="100%">
            <VisibilityPixel metrics={impressionMetrics} />

            <View
                className="editorial-content-card"
                borderRadius="8px"
                as="a"
                href={contentUrl}
                target="_self"
                onClick={emitClickMetric}
            >
                <View
                    ref={ref}
                    overflow="hidden"
                    css={{
                        ':hover': {
                            boxShadow: '0px 24px 40px rgba(53, 53, 53, 0.16)',
                        },
                    }}
                    borderRadius="8px"
                    backgroundColor="#FFFFFF"
                    height={{ _: 'inherit', sm: '100%' }}
                >
                    <View
                        width="100%"
                        overflow="hidden"
                        css={{
                            aspectRatio: '500 / 281',
                        }}
                        key={renderKey}
                    >
                        <ResponsivePicture
                            cloudinaryID={contentImage?.src}
                            alt={contentImage?.alt}
                        />
                    </View>

                    <View
                        borderRadius="0 0 8px 8px"
                        border={`1px solid ${colors.neutral[20]}`}
                        px="16px"
                        py="16px"
                        color={colors.neutral[80]}
                        css={{
                            span: {
                                ':hover': {
                                    textDecoration: 'underline',
                                    color: colors.neutral[100],
                                },
                            },
                        }}
                    >
                        <Heading
                            variant={{
                                _: 'headingXs',
                                sm: 'headingSm',
                            }}
                            color={colors.neutral[100]}
                            css={{
                                overflow: 'hidden',
                                display: '-webkit-box',
                                '-webkit-line-clamp': '3',
                                '-webkit-box-orient': 'vertical',
                            }}
                        >
                            {title}
                        </Heading>
                        <Text
                            pt="8px"
                            as="span"
                            margin="0"
                            textAlign="left"
                            variant="labelMd"
                        >
                            {`${likes} ${likeText}`}
                        </Text>
                        {'   •  '}
                        <Text
                            pt="8px"
                            as="span"
                            margin="0"
                            textAlign="left"
                            variant="labelMd"
                        >
                            {`${commentCount} ${commentText}`}
                        </Text>
                    </View>
                </View>
            </View>
            <View
                css={{
                    span: {
                        borderWidth: '0px',
                        backgroundColor: colors.secondary[10],
                        color: colors.secondary[70],
                        fontWeight: '600',
                    },
                }}
            >
                <BasicChip
                    boxShadow="0px 2px 4px rgba(0, 0, 0, 0.16)"
                    position="absolute"
                    left="16px"
                    top="16px"
                    size="medium"
                    text={labelToTextMap[label]}
                    variant="primary"
                />
            </View>
        </View>
    );
});

FeauturedArticle.displayName = 'FeauturedArticle';
